// extracted by mini-css-extract-plugin
module.exports = {"root":"jh3Ln","title":"_15Mus","currentMetric":"_1xZjd","delta":"rLtVu","baselineMetric":"_31fT3","loading":"JBvvt","large":"_2yNkw"};